export default __webpack_public_path__ + "static/bench-ab933989a527aaf1ae469404b4143201.png";